// src/admin/ManageForms.jsx
import React, { useState, useEffect } from 'react';
import { Container, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import * as endPoints from '../assets/js/endpoints';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import Loader from '../components/loader';
import { Helmet } from 'react-helmet';

const ManageForms = () => {
  const [forms, setForms] = useState([]);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  
  const fetchForms = async () => {
    try {
       setLoading(true);
      const data = await endPoints.getAllForms();    
      setForms(Array.isArray(data) ? data : data.data); // O ajusta según corresponda
    } catch (error) {
      showNotification('Error al obtener formularios', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchForms();
  }, []);

  const handleDelete = async id => {
    const ok = await confirm('¿Eliminar formulario?');
    if (!ok) return;
    try {
      setLoading(true);
      await endPoints.deleteForm(id);
      fetchForms(); // recarga la lista tras borrar
      showNotification('Formulario eliminado', 'success');
    } catch (error) {
      showNotification('Error eliminando formulario', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/pages/createForm/${id}`);
  };

  const handleCreate = () => {
    navigate('/pages/createForm');
  };

    if (loading) return <Loader />;
    
  const columns = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'tipo', label: 'Tipo' },
      { id: 'respuestas', label: 'Respuestas', sortable: false }
  ];

  const rows = forms.map(f => ({
  ...f,
  tipo: f.form_type?.name,
  respuestas: (
    <Button
      onClick={() => navigate(`/admin/manageForms/formResponses/${f.id}`)}
      startIcon={<ListAltIcon />}
      aria-label="Ver respuestas"
      sx={{ color: ACTION_ICON_COLORS.see }}
    >
      Ver respuestas
    </Button>
  )
}));

  const actions = form => (
    <>        
      <IconButton onClick={() => handleEdit(form.id)} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(form.id)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Gestión de Formularios | CES</title>
      </Helmet>
      <Container sx={{ mt: 3, mb:2, paddingBottom: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <PageTitle>Gestión de Formularios</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Formulario</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
    </>
  );
};

export default ManageForms;
